import './App.css';
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import KOTPrintTemplate from "./components/KOTPrintTemplate";


function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <AppRoutes />
        <KOTPrintTemplate />
      </NotificationProvider>
    </AuthProvider>
  );
}


export default App;
